export default __webpack_public_path__ + "static/media/art-1-soil-prep.3238cfe4.jpg";